import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import Swal from 'sweetalert2';
import imagenesEditProject from "../assets/imgEditProject/imgEditProject";
import { Link, useParams, useNavigate } from 'react-router-dom';
import withReactContent from 'sweetalert2-react-content';
import documentsProject from "../assets/Icons/documentsProject.png";

function InformactionProject() {
    const { id } = useParams();
    const cookies = new Cookies();
    const getSesion = cookies.get("Bearer");
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();

    const initialProject = {
        accept_proposals_files: "",
        allowPublish: "",
        assigned_status: "",
        budget: { id: "", range: '' },
        budget_id: "",
        chat_room: "",
        company_name: "",
        company_project_file: "",
        delivery_date: "",
        description: "",
        id: "", 
        knowledges_tags: [{ id: "", name: "" }],
        photo: "",
        project_name: "",
        public_info: "",
        publication_date: "",
        rating: "",
        s_types_id: "",
        specialization_Name: ""
    };

    const [projectsInfo, setProjectsInfo] = useState(initialProject);
    const [isLoading, setIsLoading] = useState(true);
    const [specializations, setSpecializations] = useState([]);
    const [listBudget, setListBudget] = useState([]);

    const projects = async () => {
        setIsLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URI}project/get/${id}?id_type_opportunities=4`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };
            const resp = await axios.get(url, config);
            setProjectsInfo(resp.data);
        } catch (err) {
            console.error(err);
            MySwal.fire({
                title: 'Error',
                text: 'No se pudo cargar la información del proyecto',
                icon: 'error'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const getSpecialties = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URI}Knowledge-specialization/list/types`;
            const resp = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            });
            setSpecializations(resp.data.specializationTypes || []);
        } catch (err) {
            console.error(err);
        }
    };

    const getBudget = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URI}budget`;
            const resp = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            });
            setListBudget(resp.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const applyJob = () => {
        MySwal.fire({
            title: "¿Está seguro?",
            text: "Sí, deseo enviar mi perfil para este proyecto",
            color: "#fff",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar",
            background: '#1a365d'
        }).then((result) => {
            if (result.isConfirmed) sendData();
        });
    };

    const sendData = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URI}freelancer/apply-project/${getSesion.id}`;
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };
            const newData = {
                budget: "",
                id_type_opportunities: 4,
                project_id: id,
                project_proposal: "",
            };
            
            await axios.post(url, newData, config);
            
            MySwal.fire({
                title: "¡Completado!",
                text: "Tu perfil ha sido enviado con éxito! En los próximos días recibirás una notificación sobre el proceso a través de tu correo electrónico.",
                color: "#fff",
                icon: "success",
                background: '#1a365d'
            });
            
            setTimeout(() => { navigate('/perfil-freelancer'); }, 3000);
        } catch (err) {
            MySwal.fire({
                position: 'center',
                icon: 'warning',
                title: err.response?.data?.message || 'Error al enviar la solicitud',
                showConfirmButton: false,
                timer: 3500,
                background: '#1a365d'
            });
        }
    };

    useEffect(() => {
        projects();
        getSpecialties();
        getBudget();
    }, [id]);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple flex items-center justify-center">
                <div className="text-white text-2xl">Cargando...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">
                {/* Header with back button */}
                <div className="flex items-center mb-8">
                    <button 
                        onClick={() => navigate(-1)} 
                        className="mr-4 p-2 rounded-full hover:bg-blue-700 transition-colors"
                    >
                        <img 
                            src={imagenesEditProject.arrow_back_4} 
                            className="w-8 h-8" 
                            alt="Volver" 
                        />
                    </button>
                    <h1 className="text-Yellow text-3xl font-bold">Proyecto</h1>
                </div>

                {/* Project title */}
                <h1 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
                    {projectsInfo.project_name}
                </h1>

                {/* Project description */}
                <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6 mb-8">
                    <p className="text-white text-lg leading-relaxed">
                        {projectsInfo.description}
                    </p>
                </div>

                {/* Project details grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    {/* Left column */}
                    <div className="space-y-6">
                        <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6">
                            <h2 className="text-Yellow text-xl font-semibold mb-4">Detalles del proyecto</h2>
                            
                            <div className="space-y-4">
                                {projectsInfo.public_info === 1 && <div>
                                    <h3 className="text-Yellow text-lg">Empresa</h3>
                                    <p className="text-white">
                                        {projectsInfo.company_name || 'No especificado'}
                                    </p>
                                </div>}

                                <div>
                                    <h3 className="text-Yellow text-lg">Categoría</h3>
                                    <p className="text-white">
                                        {specializations.find(s => s.id == projectsInfo.s_types_id)?.name || 'No especificado'}
                                    </p>
                                </div>
                                
                                <div>
                                    <h3 className="text-Yellow text-lg">Habilidades requeridas</h3>
                                    <div className="flex flex-wrap gap-2 mt-2">
                                        {projectsInfo.knowledges_tags.map((knowledge, index) => (
                                            <span 
                                                key={index} 
                                                className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm"
                                            >
                                                {knowledge.name}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right column */}
                    <div className="space-y-6">
                        <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6 h-full">
                            <h2 className="text-Yellow text-xl font-semibold mb-4">Información adicional</h2>
                            
                            <div className="space-y-4">
                                <div>
                                    <h3 className="text-Yellow text-lg">Presupuesto disponible</h3>
                                    <p className="text-white">{projectsInfo.budget.range}</p>
                                </div>
                                
                                <div>
                                    <h3 className="text-Yellow text-lg">Fecha de entrega</h3>
                                    <p className="text-white">{projectsInfo.delivery_date}</p>
                                </div>
                                
                                {projectsInfo.company_project_file && (
                                    <div>
                                        <h3 className="text-Yellow text-lg">Documentos adjuntos</h3>
                                        <div className="flex items-center mt-2">
                                            <img 
                                                src={documentsProject} 
                                                className="w-8 h-8 mr-2" 
                                                alt="Documento" 
                                            />
                                            <span className="text-white">Documento complementario</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Apply button */}
                <div className="text-center">
                    <button 
                        onClick={applyJob}
                        className="bg-Yellow hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300"
                    >
                        Enviar mi perfil
                    </button>
                </div>
            </div>
        </div>
    );
}

export default InformactionProject;